// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"c8a4f194","598":"6ea315ff","703":"2b7f55a4","787":"46669eae"}[chunkId] + ".chunk.js";
};